const styles = {
  sourceGrid: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "repeat(auto-fill, minmax(240px, 280px))",
    },
    gap: 2,
  },
  sourceCard: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    p: 2.5,
    border: "1.5px solid rgba(1,67,57,0.15)",
    borderRadius: "12px",
    bgcolor: "#fff",
    cursor: "pointer",
    transition: "all 0.15s",
    "&:hover": {
      borderColor: "primary.main",
      bgcolor: "rgba(1,67,57,0.03)",
    },
  },
  sourceIcon: {
    width: 44,
    height: 44,
    borderRadius: "10px",
    bgcolor: "rgba(1,67,57,0.06)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  summaryRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    mb: 2,
  },
  selectedPill: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  secondaryButton: {
    color: "purple.dark",
    textTransform: "none",
    fontSize: 13,
  },
  infoChip: {
    display: "inline-flex",
    alignItems: "center",
    flexWrap: "wrap",
    px: 1.25,
    py: 0.75,
    mb: 1.5,
    borderRadius: 2,
    bgcolor: "rgba(1,67,57,0.04)",
    fontSize: 12,
    color: "text.secondary",
  },
};

export default styles;
